<script setup lang="ts">
import { onMounted, onBeforeUnmount, computed } from 'vue';

const geowidgetToken = import.meta.env.VITE_INPOST_GEOWIDGET ?? '';

const props = defineProps({
  modelValue: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const model = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emit('update:modelValue', val);
  },
});

const changePaczkomat = () => {
  model.value = '';
};

onMounted(() => {
  const scriptElement = document.createElement('script');
  scriptElement.src = 'https://geowidget.inpost.pl/inpost-geowidget.js';
  scriptElement.defer = true;
  document.body.appendChild(scriptElement);

  const handlePointSelect = (event) => {
    model.value = event.detail.name;
  };

  document.addEventListener('onpointselect', handlePointSelect);

  onBeforeUnmount(() => {
    document.removeEventListener('onpointselect', handlePointSelect);
  });
});
</script>

<template>
  <div class="geowidget">
    <div v-if="modelValue" class="geowidget-selected">
      <p class="geowidget-selected-text">Wybrano paczkomat</p>
      <p class="geowidget-selected-paczkomat">{{ modelValue }}</p>
      <button class="geowidget-selected-button_change" @click="changePaczkomat">
        Zmień
      </button>
    </div>
    <inpost-geowidget
      v-show="!modelValue"
      class="geowidget-iframe"
      onpoint="onpointselect"
      :token="geowidgetToken"
      language="pl"
      config="parcelcollect"
    ></inpost-geowidget>
  </div>
</template>

<style lang="scss">
.geowidget {
  width: 100%;
  height: 100%;

  &-iframe {
    height: 100%;
    min-height: 500px;

    iframe {
      min-height: 500px;
    }
  }
}
</style>

<style lang="scss" scoped>
.geowidget {
  font-size: 16px;

  &-selected {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;

    &-text {
      font-size: 1.25em;
      font-weight: 700;
    }

    &-paczkomat {
      font-size: 1.25em;
    }

    &-button_change {
      font-size: 1.05em;
      font-weight: 700;
      border-radius: 14px;
      border: 2px solid $brown-200;
      padding: 5px 15px;
      cursor: pointer;
      transition: ease 0.7s all;
      background-color: $brown-200;
      color: $white-100;

      &:hover {
        background-color: $white-100;
        color: $brown-200;
      }
    }
  }
}
</style>
